const numberFormatter = new Intl.NumberFormat('nb-NO');
const percentFormatter = new Intl.NumberFormat('nb-NO', {
  style: 'percent',
  maximumFractionDigits: 1,
});

export const formatNumber = (value: number): string =>
  numberFormatter.format(value);

export const formatPercent = (value: number): string =>
  percentFormatter.format(value);

export const formatShare = (
  count: number,
  total: number | undefined
): string =>
  total == null || total === 0 ? '–' : percentFormatter.format(count / total);
